// @core/api/endpoints/authn/rotate_oauth2_client_secret.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RotateOAuth2ClientSecretRequest,
  RotateOAuth2ClientSecretResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Rotate OAuth2 client secret
 * Generates a new client secret while temporarily keeping the old one valid for a grace period. Returns the new secret which is only shown once.
 */
export async function RotateOAuth2ClientSecret(
  client_id: string,
  data: RotateOAuth2ClientSecretRequest,
  options?: RequestOptions
): Promise<RotateOAuth2ClientSecretResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/clients/:client_id/rotate-secret`;
  requestPath = requestPath.replace(':client_id', encodeURIComponent(client_id));
  const requestOptions = options;
  return client.post<RotateOAuth2ClientSecretResponse>(requestPath, data, requestOptions);
}
